import React from "react";

const Reports = props => (
  <svg viewBox="0 0 22 21" fill="none" {...props}>
    <path
      d="M10.958 9.875v-8.71c0-.353.235-.665.625-.665 4.805 0 8.75 3.945 8.75 8.75 0 .352-.312.625-.664.625h-8.71zM18.341 8a7.013 7.013 0 00-5.508-5.508V8h5.508zM9.083 2.453v9.297l6.094 6.133c.274.273.235.703-.039.898a9.44 9.44 0 01-5.43 1.719 9.353 9.353 0 01-9.375-9.375c0-4.727 3.516-8.633 8.047-9.258a.59.59 0 01.703.586zM7.208 12.531V4.055c-2.93 1.054-5 3.828-5 7.07 0 4.14 3.32 7.5 7.5 7.5a7.595 7.595 0 002.97-.586l-5.47-5.508zm13.672-.781c.352 0 .664.313.586.664A9.152 9.152 0 0118.576 18a.604.604 0 01-.82-.04l-6.173-6.21h9.297z"
      fill="currentColor"
    />
  </svg>
);

export default Reports;
